<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:170px;">
                        <el-select v-model="form.projectType" placeholder="请选择项目" clearable>
                            <el-option
                                v-for="item in projectTypeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1; getData()">查询</el-button>
                </div>
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary" class="handle-del mr10" icon="el-icon-plus" @click="setAdd()">新增</el-button>
                </div>
            </div>

            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255,255,0.7)"
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="projectType" label="项目" min-width="120">
                    <template slot-scope="scope">
                        {{ projectTypeLabel(scope.row.projectType) }}
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="说明" min-width="260" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="privilege" label="特权" min-width="260" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column fixed="right" label="操作" width="140">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="setUpdate(scope.row)" type="text" size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)" type="text" size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
    </div>
</template>

<script>
import http from '../../../../common/http';
import add from './Add.vue';
import update from './Update.vue';

export default {
    name: 'MemberPrivilege',
    data(){
        return{
            addVisible: false,
            updateVisible: false,
            loading: false,
            loadingText: '',
            menuName: '',
            data: [],
            form: {
                id: '',
                projectType: ''
            },
            common: {
                total: 0,
                pageSize: 30,
                page: 1,
                isPage: 1,
                allSizes: [30, 50, 100]
            },
            projectTypeOptions: [
                { value: '1', label: 'AI智伴' },
                { value: '2', label: '校园通话' },
                { value: '3', label: '语音留言' },
                { value: '4', label: '智能校徽' }
            ]
        };
    },
    components: {
        add,
        update
    },
    created:function () {
        this.menuName = sessionStorage.getItem('selectMenuItem_key');
        this.getData();
    },
    methods:{
        indexMethod(index) {
            return (this.common.page - 1) * this.common.pageSize + (index + 1);
        },
        getData(){
            this.loading = true;
            this.loadingText = '数据加载中...';
            let url  = this.memberPrivilegeListUrl;
            let data = {
                projectType: this.form.projectType
            };
            this.apiPost(url, data).then((res) => {
                this.loading = false;
                if(res.status == 200){
                    this.data = res.data.list || res.data.data || [];
                    this.common.total = res.data.total || 0;
                }else{
                    this.$commonFn.showTip(res.message,3);
                }
            },(err)=>{
                console.log(err);
                this.loading = false;
            });
        },
        setAdd(){
            this.addVisible = true;
            this.$nextTick(() => {
                this.$refs['add'].init();
            });
        },
        setUpdate(row){
            this.updateVisible = true;
            this.$nextTick(() => {
                this.$refs['update'].init(row);
            });
        },
        del(row){
            this.form.id = row.id;
            this.$commonFn.showConfirm(this.delSuccess);
        },
        delSuccess(){
            let url = this.memberPrivilegeRemoveUrl;
            let data = { id: this.form.id };
            this.apiPost(url, data).then((res)=>{
                if(res.status === 200){
                    this.$commonFn.showTip(res.message,1);
                    this.common.page = 1;
                    this.getData();
                }else{
                    this.$commonFn.showTip(res.message,3);
                }
            },(err)=>{
                console.log(err);
            });
        },
        projectTypeLabel(v){
            if(v == 1 || v == '1') return 'AI智伴';
            if(v == 2 || v == '2') return '校园通话';
            if(v == 3 || v == '3') return '语音留言';
            if(v == 4 || v == '4') return '智能校徽';
            return '-';
        }
    },
    mixins: [http]
};
</script>

<style scoped>
.table{
    width: 100%;
    font-size: 14px;
}
.mr10{
    margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/member/privilege/Privilege.vue